module.exports = __webpack_public_path__ + "seller/img/logo.8030d076.png";